module.exports = __webpack_public_path__ + "static/media/sonic-pricing-table.0a44492a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sonic-pricing-table.png
// module id = 431
// module chunks = 0